import { Card, Text, Heading } from "@aidron/aidron-ds";

import { i18n } from "../../../../../translate/i18n";

import { CustomHeading, CustomText } from "../../../../../components/StyledComponents/styleComponents.index";

import PropTypes from "prop-types";

import ChannelReplenishment from "../../../../../assets/image/_Abastecimento de Canais.png";
import PuchaseAdjustment from "../../../../../assets/image/_ajuste-de-compra.png";
import AssortmentOtimization from "../../../../../assets/image/_adjustment-plan.png"

import { useContext } from "react";
import { TenantContext } from "../../../../../templates/context/TenantContext";

import { currencyFormatter } from "../../../../../utils/formatter/formatter";

const ModuleAwaitngForImplementation = () => {
  return(
    <CustomText
      color="lightGrey"
      fontSize={['0.4rem', '0.6rem', '1rem']}
      weight="bold">
      {"Módulo não implementado"}
    </CustomText>
  )
}

export function AssortmentCard({ ctx }) {
  
  const { number, variant } = ctx || {};
  
  const { t } = i18n;

  const { hasAdjustmentPlan, hasChannelOpportunities, hasAssortmentManagement } = useContext(TenantContext);

  const formattedPercent = new Intl.NumberFormat("pt-BR", {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(parseFloat(number) / 100);

  const renderContent = () => {
    switch (variant) {
      case "channel":
        return (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: `${!hasChannelOpportunities ? "0rem" : "1rem"}`, height: `${!hasChannelOpportunities ? "170px" : "156px" }` }}>
            {
              !hasChannelOpportunities ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "2rem" }}>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem", width: "70%" }}>
                    <img src={ChannelReplenishment} style={{ width: "30%", height: "60%" }}/>
                    <Heading size="sm">{t("channelReplenishment").toUpperCase()}</Heading>
                  </div>
                  
                  <div
                    style={{
                        display: "flex",
                        flexDirection: 'column',
                        alignItems: "center",
                        textAlign: 'center',
                        maxInlineSize: '50%',
                        inlineSize: '320px',
                        border: !hasChannelOpportunities ? "1px dotted #5f5e5e" : "none",
                        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                        blockSize: "auto",
                        position: "relative", bottom: "4px" 
                      }}>
                    <ModuleAwaitngForImplementation/>
                  </div>
                </div>
                
              ) : (
                <>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "1rem", width: "70%" }}>
                    <img src={ChannelReplenishment} style={{ width: "22.5%", height: "80%" }}/>
                    <Heading size="sm">{t("channelReplenishment").toUpperCase()}</Heading>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: `${!hasChannelOpportunities ? "118px" : "auto"}` }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: 'column',
                        alignItems: "center",
                        textAlign: 'center',
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                        inlineSize: "100%",
                        borderRadius: "0.4rem",
                        blockSize: "auto",
                        inlineSize: '320px',
                        maxInlineSize: '100%'
                      }}>

                      <CustomHeading
                        fontSize={['0.3rem', '0.6rem', '1.3rem']} color="mediumGrey">
                        Ações de Curto Prazo
                      </CustomHeading>

                      <CustomText color="orange" weight="bold" fontSize={['1rem', '1.2rem', '1.8rem']}>
                        {number}
                      </CustomText>

                      <CustomText color="mediumGrey" weight="bold" fontSize={['0.4rem', '0.6rem', '0.8rem']}>
                        {"em risco evitado de perda de vendas"}
                      </CustomText>
                    </div>
                  </div>
                </>
              )
            }
          </div>
        );

      case "purchaseAdjustment":

        const isValidNumber = (value) => typeof value === "number" && !isNaN(value);

        const hasValidData = isValidNumber(number?.overstock) && isValidNumber(number?.increaseInSales);

        const ifNotValidValueShowWaitingMessage = {
          overstock: isValidNumber(number?.overstock)
            ? currencyFormatter.format(number.overstock)
            : t("waitingForData"),

          increaseInSales: isValidNumber(number?.increaseInSales)
            ? currencyFormatter.format(number.increaseInSales)
            : t("waitingForData")
        };
             
        return (
          <>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem", width: "80%" }}>
                <img src={PuchaseAdjustment} style={{ width: "15%", height: "15%" }} />
                <Heading size="sm">{t("purchaseAdjustment").toUpperCase()}</Heading>
              </div>          
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "start", inlineSize: "fit-content", gap: `${!hasAdjustmentPlan ? "2rem" : "0rem"}` }}> 
              {
                !hasAdjustmentPlan || !hasValidData ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: `${!hasAdjustmentPlan ? "126px" : "auto"}` }}>
                    <div 
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        border: "1px dotted #5f5e5e",
                        padding: "1.1rem 0rem",
                        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                        inlineSize: "100%",
                        blockSize: "26px",
                        justifyContent: "center",
                        textAlign: 'center',
                        maxInlineSize: '100%',
                        padding: '1rem'
                      }}>
                      <ModuleAwaitngForImplementation/>
                    </div>                  
                  </div>
                ) : (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: "1rem 0rem" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          border: "1px solid #e5e7eb",
                          borderRadius: "0.4rem",
                          padding: "1rem 0.4rem",
                          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                          inlineSize: "100%",
                          gap: "0.3rem",
                          blockSize: "1rem",
                          maxInlineSize: '100%',
                          textAlign: 'center'
                        }}>
                        
                        <CustomText 
                          display="inline"
                          color="orange" 
                          weight="bold" 
                          fontSize={['0.4rem', '0.9rem', '1.2rem']} 
                          inlineSize={"50%"}
                        >
                          {ifNotValidValueShowWaitingMessage?.overstock}
                        </CustomText>

                        <CustomText
                          weight={"bold"}
                          fontSize={['0.2rem', '0.5rem', '1rem']}
                          lineHeight="1rem"
                          style={{ color: "#000", fontWeight: "600", whiteSpace: "normal" }}
                        >
                          {t("avoidedStockSurplus")}
                        </CustomText>
                      </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          border: "1px solid #e5e7eb",
                          borderRadius: "0.4rem",
                          padding: "0 0.4rem",
                          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                          inlineSize: "100%",
                          gap: "0.3rem",
                          blockSize: "3rem",
                          textAlign:'center',
                          maxInlineSize: '100%',
                        }}>

                        <CustomText 
                          color="orange" 
                          weight="bold" 
                          fontSize={['0.4rem', '0.9rem', '1.2rem']} 
                          inlineSize={"100%"}
                          display="inline">
                          {ifNotValidValueShowWaitingMessage?.increaseInSales}
                        </CustomText>

                        <CustomText
                          display="inline"
                          inlineSize={"100%"}
                          weight={"bold"}
                          padding={"0 1.4rem"}
                          lineHeight="1rem"
                          fontSize={['0.2rem', '0.5rem', '1rem']}
                          style={{ color: "#000", fontWeight: "600", whiteSpace: "normal" }}>
                            {t("increaseInSales")}
                        </CustomText>
                        
                      </div>
                    </div> 
                  </>
                )
              }  
            </div>
          </>
        );

      case "assortment":
        return (
          <>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "fit-content", gap: "0.5rem" }}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem", width: "60%" }}>
                <img src={AssortmentOtimization} style={{ width: "18.5%", height: "18.5%" }}/>
                <Heading size="sm">{t("assortmentOptimization").toUpperCase()}</Heading>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: `${!hasAssortmentManagement ? "120px" : "110px"}` }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: !hasAssortmentManagement ? "1px dotted #5f5e5e" : "none",
                  padding: "0.4rem 1.7rem",
                  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                  inlineSize: "100%",
                  gap: "0.75rem",
                  height: !hasAssortmentManagement ? "40px" : "auto",
                  justifyContent: "center",
                  textAlign: 'center',
                  maxInlineSize: '100%'
                }}>

                {
                  !hasAssortmentManagement ? (
                    <ModuleAwaitngForImplementation/>
                  ) : (
                    <>
                      <CustomText
                        color="orange"
                        weight="bold"
                        fontSize={['0.5rem', '1.7rem', '2rem']}
                      >
                        {number < 0 ? "↑" : "↓"} {formattedPercent}
                      </CustomText>

                      <Text label="Oportunidade de Otimização" />
                    </>
                  )
                }
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <div 
      style={{
        blockSize: '100%',
        inlineSize: '100%',
        minInlineSize: '239px',
        maxInlineSize: '100%',
        marginBlockEnd: '20px'
      }}>
      <Card
        style={{
          border: "1px solid #e5e7eb",
          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: `
            ${!hasAdjustmentPlan ? "0rem" : "1.5rem"}
            ${!hasAssortmentManagement ? "0rem" : "1.5rem"}
            ${!hasChannelOpportunities ? "0rem" : "1.5rem"}
          `,
          padding: "1rem 0rem",
        }}
      >
        {renderContent()}
      </Card>
    </div>
  );
}

AssortmentCard.propTypes = { ctx: PropTypes.shape() };